<template>
  <div class="mobile mission-item" :class="locale">
    <div class="row row1">
      <div class="row1-left">
        <div class="title">
          {{ $t(`mwr.mission.list.${props.mission.id}.title`) }}
        </div>
        <div class="desc">
          {{ $t(`mwr.mission.list.${props.mission.id}.desc`) }}
        </div>
      </div>
      <div class="turn">
        <div class="turn-text">
          {{ $t('mwr.turnNum', { num: getTurn(props.mission.key) }) }}
        </div>
      </div>
    </div>
    <div class="row row2">
      <div class="progress-text">
        {{ $t('mwr.mission.progress') }}
      </div>
      <div class="progress">
        {{ getCurrent() }} / {{ props.mission.totle }}
      </div>
    </div>
    <div class="row row3">
      <div class="progress-bar">
        <div class="progress-bar-inner" :style="{ width: getCurrent() / props.mission.totle * 100 + '%' }"></div>
      </div>
    </div>
    <div class="row row4">
      <div class="button btn-can-receive" v-if="getStatus(props.mission.key) === 1" @click="handleReceiveReward">
        <div class="btn-text">
          {{ $t('mwr.mission.btns.canReceive') }}
        </div>
      </div>
      <div class="button btn-received" v-else-if="getStatus(props.mission.key) === 2">
        <div class="btn-text">
          {{ $t('mwr.mission.btns.received') }}
        </div>
      </div>
      <template v-else-if="getStatus(props.mission.key) === 0">
        <div class="button btn-share" @click="handleShareImmediate" v-if="props.mission.key === 'shareMwr'">
          <div class="btn-text">
            {{ $t('mwr.mission.btns.shareImmediate') }}
          </div>
        </div>
        <div class="button btn-not-reach" v-else>
          <div class="btn-text">
            {{ $t('mwr.mission.btns.notReach') }}
          </div>
        </div>
      </template>
      <div v-else>
        <!-- {{ JSON.stringify(props.mission) }} -->
      </div>
    </div>
    <ShareDialog v-model="state.shareDialog.visible" @shareSuccess="handleShareSuccess" type="shareDragon" />
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { inject, reactive } from 'vue'
import { defineProps } from 'vue'
import ShareDialog from '../../../components/Dialog/ShareDialog/index.vue'
import MwrActApi from '@/config/mwrActApi'
import { toastService } from '@/utils/toastService'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()
const mwrData = inject('mwrData')
const mwrFn = inject('mwrFn')
const props = defineProps({
  mission: {
    type: Object,
    default: () => ({})
  },
})
const state = reactive({
  shareDialog: {
    visible: false
  }
})
const getTurn = (key) => {
  return mwrData.commonConfig.taskTypeCountMap[key]
}
const getStatus = (key) => {
  return mwrData.taskDetail[key]
}
const getCurrent = () => {
  const { key } = props.mission
  const { loginDays, dailyPlayedModeCount, newModeCount } = mwrData.taskDetail.countDetail
  if (key === 'dailyLogin') {
    return mwrData.taskDetail.dailyLogin >= 1 ? 1 : mwrData.taskDetail.dailyLogin
  }
  if (key === 'loginDaysGt3') {
    return loginDays >= 3 ? 3 : loginDays
  }
  if (key === 'loginDaysGt7') {
    return loginDays >= 7 ? 7 : loginDays
  }
  if (key === 'dailyPlayThreeMode') {
    return dailyPlayedModeCount >= 3 ? 3 : dailyPlayedModeCount
  }
  if (key === 'playedFiveNewMode') {
    return newModeCount >= 5 ? 5 : newModeCount
  }
  if (key === 'shareMwr') {
    return [1, 2].includes(mwrData.taskDetail.shareMwr) ? 1 : 0
  }
  return 0
}
const handleShareImmediate = () => {
  if (!mwrData.cpUserInfo.cpUserId) {
    toastService.showSmall(t('payment.validateUser.noUserText'))
    return
  }
  state.shareDialog.visible = true
}
const handleShareSuccess = async () => {
  if (mwrData.taskDetail.shareMwr !== 0) {
    return
  }
  await MwrActApi.recordUserAction({
    actionType: 'shareMwr',
  })
  mwrFn.updateShareTaskStatus()
}

const handleReceiveReward = async () => {
  const status = getStatus(props.mission.key)
  if (status !== 1) {
    toastService.showSmall(t('mwr.mission.btns.notReach'))
    return
  }
  console.log('handleReceiveReward', props.mission.key)
  await MwrActApi.receiveTaskReward({
    taskType: props.mission.key,
  })
  const turn = getTurn(props.mission.key)
  mwrFn.updateTotalShotCount(turn) // 更新总射击次数
  mwrFn.updateTaskStatus(props.mission.key, 2) // 更新任务状态
  toastService.showSmall(t('mwr.mission.receiveRewardSuccess'))
}
</script>

<style scoped lang="less" src="./mobile_style_item.less"></style>